import {db, firebaseApp} from "../../firebase";
import {getUid} from "../auth";
import {Collections} from "../collections";
import "firebase/compat/functions";
import {StudentCvInterface} from "../../db/models/student/cv";

export const getCvListener = (observer) => {
    const uid = getUid();
    if (!uid) return;
    return db.collection(Collections.STUDENT_CVS).doc(uid).onSnapshot(observer);
};

export const getCvListenerWithUid = (uid, observer) => {
    if (!uid) return;
    return db.collection(Collections.STUDENT_CVS).doc(uid).onSnapshot(observer);
};

export const rmMaterialFeedback = (feedback, materialPath, competence) => {
    if (!feedback) return Promise.reject();

    const callable = firebaseApp.functions("europe-west1").httpsCallable("onRmMaterialFeedback");
    return callable({feedback, materialPath, competence});
}

export const updateStudentCvSoftSkills = (u, softSkills) => {
    if (!u || !softSkills) return Promise.reject("Bad params");

    return db
        .collection(Collections.STUDENT_CVS)
        .doc(u)
        .set({softSkills}, {merge: true});
};

export const updateCv = (u, softSkills) => {
    if (!u || !softSkills) return Promise.reject("Bad params");

    return db
        .collection(Collections.STUDENT_CVS)
        .doc(u)
        .set({softSkills}, {merge: true});
};

export const updateCvQrsp = (userId, qrspObject) => {
    if (!userId || !qrspObject) return Promise.reject("Bad params");

    return db
        .collection(Collections.STUDENT_CVS)
        .doc(userId)
        .set(qrspObject, {merge: true});
};

export const updateCvQrspCourses = (userId, courses) => {
    if (!userId || !courses) return Promise.reject("Bad params");

    return db
        .collection(Collections.STUDENT_CVS)
        .doc(userId)
        .set({qrspCourses: courses}, {merge: true});
};
export const updateCvQrspActivities = (userId, activities) => {
    if (!userId || !activities) return Promise.reject("Bad params");

    return db
        .collection(Collections.STUDENT_CVS)
        .doc(userId)
        .set({qrspActivities: activities}, {merge: true});
};

export const updateCvQrspCourse = (course) => {
    const uid = getUid();
    if (!uid || !course) return Promise.reject("Bad params");

    return db
        .collection(Collections.STUDENT_CVS)
        .doc(uid)
        .update(`qrspCourses.${course.id}`, course);
};

export const getStudentCV = () => {
    const uid = getUid();
    if (!uid) return;
    return db
        .collection(Collections.STUDENT_CVS)
        .doc(uid)
        .get()
        .then((doc) => {
            if (doc.exists) return doc.data();
            else return null;
        });
};

export const getStudentCvById = (id) => {
    if (!id) return Promise.resolve(null);

    return db
        .collection(Collections.STUDENT_CVS)
        .doc(id)
        .get()
        .then((doc) => {
            if (doc.exists) {
                return doc.data() as StudentCvInterface;
            } else return null;
        });
};

export const getStudentCVListener = (observer) => {
    const uid = getUid();
    if (!uid) return Promise.reject("no uid");
    return db.collection(Collections.STUDENT_CVS).doc(uid).onSnapshot(observer);
};